//@flow
/**
 * Question actions
 * @module question/actions
 */
import ReactGA from 'react-ga'
import localforage from 'localforage'
import {
  FETCH_QUESTION_REQUEST,
  FETCH_QUESTION_PENDING,
  FETCH_QUESTION_SUCCESS,
  FETCH_QUESTION_FAILURE,
  PRELOAD_QUIZ_PATH,
} from './reducer'

import socket from '../../socket'

const questionsStore = localforage.createInstance({
  name: 'questions',
})

/**
 * Fetches question data for the specified id.
 * @memberof question/actions
 */
export const fetchQuestion = (
  questionId: string,
  reset: ?boolean = false,
) => async (dispatch: Function, getState: Function) => {
  const { questions } = getState()
  if (!reset && questions.get('requested').has(questionId)) return
  dispatch({
    type: FETCH_QUESTION_REQUEST,
    payload: questionId,
  })

  // get the question from offline cache
  dispatch({
    type: FETCH_QUESTION_PENDING,
    payload: await questionsStore.getItem(questionId),
  })

  // refetch the question from server just incase there is an update
  socket.emit(
    'questions:get',
    questionId,
    (err: Error, question: Question): void => {
      if (err) {
        return dispatch({
          type: FETCH_QUESTION_FAILURE,
          payload: err,
          error: true,
        })
      }

      questionsStore.setItem(questionId, question)
      dispatch({
        type: FETCH_QUESTION_SUCCESS,
        payload: question,
      })
      ReactGA.event({
        category: 'Questions',
        action: 'Accessed Question',
        label: questionId,
      })
    },
  )
}

/**
 * Sets the preload path of the quiz.
 * @memberof question/action
 */
export function setPreloadQuizPath(path: Array<string>) {
  return { type: PRELOAD_QUIZ_PATH, payload: path }
}



// WEBPACK FOOTER //
// ./src/state/questions/actions.js